import { cn } from '../../lib/utils';

/** Three-group progress bar: Neu (paper) / In Arbeit (yellow) / Gelernt (ink). */
export function GroupBar({
  neu,
  inProgress,
  learned,
  className,
  delay = 0,
}: {
  neu: number;
  inProgress: number;
  learned: number;
  className?: string;
  delay?: number;
}) {
  const total = neu + inProgress + learned;
  const segs = [
    { v: neu, c: '#EFE9DC' },
    { v: inProgress, c: '#F4D03F' },
    { v: learned, c: '#161512' },
  ];
  return (
    <div className={cn('h-3 overflow-hidden rounded-[7px] border-2 border-ink bg-track', className)}>
      <div className="flex h-full origin-left animate-grow" style={{ animationDelay: `${delay}ms` }}>
        {total > 0 &&
          segs.map((s, i) =>
            s.v > 0 ? (
              <div
                key={i}
                style={{
                  width: `${(s.v / total) * 100}%`,
                  background: s.c,
                  borderLeft: i > 0 ? '1px solid rgba(22,21,18,.25)' : undefined,
                }}
              />
            ) : null
          )}
      </div>
    </div>
  );
}

/** Course glyph tile: first letter of the course name in Zen Maru. */
export function CourseGlyph({
  name,
  active,
  size = 46,
  className,
}: {
  name: string;
  active?: boolean;
  size?: number;
  className?: string;
}) {
  const glyph = Array.from(name.trim())[0]?.toUpperCase() ?? '?';
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-tile border-2 border-ink font-term font-black',
        active ? 'bg-marker' : 'bg-cream',
        className
      )}
      style={{ width: size, height: size, fontSize: size * 0.52 }}
    >
      {glyph}
    </div>
  );
}
